import { apiPost, apiGet, apiPut, apiDelete } from "./auth/apiClient";
const API_BASE = process.env.API_URL || "https://localhost:3001";
export async function extractQuote(emailBody, subject) {
    return apiPost("/api/quote/extract", { email_body: emailBody, email_subject: subject });
}
export async function submitQuoteAction(payload) {
    return apiPost("/api/quote/action", payload);
}
// ── Send drafted reply via Microsoft Graph (reply-all to the original email) ─
export async function sendReplyEmail(payload) {
    return apiPost("/api/quote/send-reply", payload);
}
// ── Email templates (user-email-templates feature) ──────────────────────────
export async function listEmailTemplates() {
    return apiGet("/api/templates");
}
export async function createEmailTemplate(body) {
    return apiPost("/api/templates", body);
}
export async function updateEmailTemplate(id, body) {
    return apiPut(`/api/templates/${id}`, body);
}
export async function deleteEmailTemplate(id) {
    return apiDelete(`/api/templates/${id}`);
}
export async function runAgent(payload) {
    return apiPost("/api/agent/run", payload);
}
// SSE stream for live agent progress. withCredentials is required so the
// session cookie is sent on this cross-origin GET — without it the
// auth-protected stream endpoint returns 401 and no events arrive.
export function streamAgent(sessionId) {
    return new EventSource(`${API_BASE}/api/agent/stream/${sessionId}`, { withCredentials: true });
}
export async function fetchRates(fields, opts) {
    return apiPost("/api/agent/run", Object.assign(Object.assign(Object.assign({ email_body: [
            `Origin: ${fields.origin || "N/A"}`,
            `Destination: ${fields.destination || "N/A"}`,
            `Equipment Type: ${fields.equipment_type || "Dry Van"}`,
            `Weight: ${fields.weight || "N/A"}`,
            `Commodity: ${fields.commodity || "N/A"}`,
            `Shipper: ${fields.shipper_name || "N/A"}`,
            `Pickup Date: ${fields.pickup_date || "N/A"}`,
            `Delivery Date: ${fields.delivery_date || "N/A"}`,
            `Special Instructions: ${fields.special_instructions || "N/A"}`,
        ].join("\n"), 
        // Send the user-confirmed fields STRUCTURED so the backend treats them as
        // authoritative (esp. the dropdown equipment) instead of re-extracting them
        // from the synthetic email_body above and overriding the selection.
        fields }, ((opts === null || opts === void 0 ? void 0 : opts.quote_id) ? { quote_id: opts.quote_id } : {})), ((opts === null || opts === void 0 ? void 0 : opts.internet_message_id) ? { internet_message_id: opts.internet_message_id } : {})), ((opts === null || opts === void 0 ? void 0 : opts.session_id) ? { session_id: opts.session_id } : {})));
}
